import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromAuth from '../../auth/reducers';

@Component({
  selector: 'portal-messaging-wrapper',
  template: `
    <div
      *ngIf="useV3Messaging$ | async; else legacyMessaging"
      style="height: 100%"
    >
      <!-- V3 Messaging Component -->
      <portal-messaging-page></portal-messaging-page>
    </div>

    <ng-template #legacyMessaging>
      <!-- Legacy Messaging Component -->
      <portal-conversation-component></portal-conversation-component>
    </ng-template>
  `
})
export class MessagingWrapperComponent implements OnInit {
  useV3Messaging$: Observable<boolean>;

  constructor(
    private _store: Store<fromAuth.State>,
    private _route: ActivatedRoute
  ) {}

  ngOnInit() {
    // Check clinic options to determine which messaging implementation to use
    this.useV3Messaging$ = this._store.pipe(
      select(fromAuth.getMessagingV3Enabled),
      map((enabled) => (enabled !== undefined ? enabled : false))
    );
  }
}
